import type { SVGProps } from 'react';

const SvgAnnotationColorPalette = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20.75 9.88c-.79-3.38-3.61-6.08-7.03-6.72-2.86-.53-5.71.28-7.82 2.23-2.11 1.94-3.15 4.71-2.85 7.58.42 3.96 3.57 7.28 7.49 7.91a9 9 0 0 0 2.79.02c1-.15 1.84-.84 2.17-1.79.34-.95.12-2-.56-2.74l-.15-.17c-.21-.21-.31-.49-.29-.79s.17-.56.42-.74c.38-.27.98-.19 1.36.19.73.73 1.79.98 2.77.66s1.69-1.15 1.84-2.17c.18-1.15.13-2.32-.14-3.48zm-1.83 3.18c-.06.39-.36.53-.49.57a.7.7 0 0 1-.73-.17c-1.07-1.07-2.76-1.24-3.94-.4-.72.52-1.18 1.32-1.25 2.2s.25 1.74.84 2.33l.12.13a.72.72 0 0 1-.43 1.2c-.71.11-1.45.1-2.18-.02-3.05-.49-5.49-3.07-5.82-6.15a6.97 6.97 0 0 1 2.21-5.91A6.95 6.95 0 0 1 12 4.99c.45 0 .9.04 1.35.13 2.65.49 4.83 2.59 5.45 5.21.21.91.25 1.83.11 2.72z"
    />
    <path
      fill="currentcolor"
      d="M14 10.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-5 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m.5 4.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
  </svg>
);
export default SvgAnnotationColorPalette;
